<template>
  <section class="page-wrap">
    <!-- 顶部操作 start -->
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="formData"
      @Refresh="onHandleRefresh"
      @search="onHandleSearch"
    >
      <template v-slot:right>
        <el-button
          @click="exportHandle"
          :disabled="disabledExport"
          type="warning"
          icon="el-icon-upload2"
          >导出</el-button
        >
      </template>
    </Filtersearch>

    <!-- 列表 start -->
    <section class="content-wrap">
      <table-list v-loading="loadingData" :tableData="tableData"></table-list>
    </section>
    <!-- 列表 end -->

    <!-- 分页 start -->
    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        :current-page="formData.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->
  </section>
</template>
<script>
import { postSettlementLogisticsPromotionList } from "@/api/generalControl/promotion.js";
import TableList from "./modules/table-list/index.vue";
import cloneDeep from "lodash/cloneDeep";
import Filtersearch from "@/components/Filtersearch.vue";
import { postSettlementLogisticsPromotionListExport } from "@/api/export/center.js";
import { formatDate } from "@/utils//tools/date.js";

export default {
  name: "city-reward-settlement",
  components: { TableList, Filtersearch },
  data() {
    return {
      total: 0,
      loadingData: false,
      formData: {
        page: 1,
        pageSize: 100,
        bank_username: "",
        tdc_id: "",
        logistics_business_id: "",
        time: [],
        start_time: "",
        end_time: "",
      },
      formDataClone: {}, // 复制数据，用于初始化
      tableData: [], //列表数据
      Filtersearchlist: [
        {
          type: "daterange",
          name: "结算日期",
          clearable: true,
          model: "time",
          startmodel: "start_time",
          endmodel: "end_time",
          startplaceholder: "开始时间",
          endplaceholder: "结束时间",
        },
        {
          type: "select",
          name: "集配中心",
          clearable: true,
          filterable: true,
          model: "logistics_business_id",
          placeholder: "请选择集配中心",
          selectoptionname: "logistic_business_list",
          label: "name",
          value: "id",
          selectoption: [],
        },
        {
          type: "select",
          name: "城市仓",
          clearable: true,
          filterable: true,
          model: "tdc_id",
          placeholder: "请选择城市仓",
          label: "name",
          value: "id",
          selectoptionname: "cityList",
          selectoption: [],
        },
        {
          type: "input",
          name: "持卡人姓名",
          clearable: true,
          model: "bank_username",
          placeholder: "请输入持卡人姓名",
        },
      ],
      disabledExport: false,
    };
  },
  created() {
    this.formDataClone = cloneDeep(this.formData);
    this.formData.time = this.getLastMonthRange();
    this.formData.start_time = this.getLastMonthRange()[0];
    this.formData.end_time = this.getLastMonthRange()[1];
    this.initData();
  },
  methods: {
    /**
     * 获取近一个月的起止日期（格式化后）
     * @param {string} format - 日期格式，默认'YYYY-MM-DD'
     * @returns {Array} [startDate, endDate] - 格式化后的起止日期数组
     */
    getLastMonthRange(format = "YYYY-MM-DD") {
      // 结束日期：今天
      const endDate = new Date();
      // 开始日期：一个月前的今天
      const startDate = new Date();
      startDate.setMonth(startDate.getMonth() - 1);

      // 使用formatDate格式化日期
      const start = formatDate(startDate, format);
      const end = formatDate(endDate, format);

      return [start, end];
    },
    /**
     * 导出明细
     */
    async exportHandle() {
      this.disabledExport = true;
      try {
        const query = {
          ...this.formData,
          token: sessionStorage.getItem("token"),
        };
        delete query.page;
        delete query.pageSize;
        await postSettlementLogisticsPromotionListExport(query);
        this.goExportCenter();
      } catch (err) {
        this.disabledExport = false;
        console.log("ajax postSettlementLogisticsPromotionListExport err", err);
      }
    },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
    /**
     * 获得集配中心列表
     */
    async ajaxGetBusinessList() {
      try {
        const { data } = await this.$api.general.businessList();
        this.businessList = data;
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "logistic_business_list"
          ) {
            // console.log(el.selectoptionname,res.data[el.selectoptionname])
            el.selectoption = data;
          }
        });
        console.log("ajax ajaxGetBusinessList", data);
      } catch (err) {
        console.log("ajax ajaxGetBusinessList err", err);
      }
    },
    // 获取城市仓列表
    async citylist() {
      try {
        const res = await this.$api.general.logisticsList({
          name: "",
          page: 1,
          pageSize: 1000,
        });
        console.log(res, "res");
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "cityList"
          ) {
            el.selectoption = [...res.data];
          }
        });
      } catch (error) {
        console.log(error, "logisticsList");
      }
    },
    /**
     * 每页条数发生改变
     */
    onHandleSizeChange(val) {
      this.formData.pageSize = val;
      this.postAjaxSettlementLogisticsPromotionList();
    },
    /**
     * 页码发生改变
     */
    onHandleCurrentChange(val) {
      this.formData.page = val;
      this.postAjaxSettlementLogisticsPromotionList();
    },
    /**
     * 查询
     */
    onHandleSearch(e) {
      this.formData = e;
      this.formData.page = 1;
      this.postAjaxSettlementLogisticsPromotionList();
    },
    /**
     * 初始化数据
     */
    initData() {
      this.postAjaxSettlementLogisticsPromotionList();
      this.ajaxGetBusinessList();
      this.citylist();
    },
    /**
     * 重置数据
     */
    onHandleRefresh() {
      this.formData = {
        ...this.formDataClone,
      };
      this.postAjaxSettlementLogisticsPromotionList();
    },
    /**
     * 获得列表数据
     */
    async postAjaxSettlementLogisticsPromotionList() {
      this.loadingData = true;
      try {
        const { data } = await postSettlementLogisticsPromotionList(
          this.formData
        );
        this.tableData = data.data;
        this.total = data.total;
      } catch (err) {
        console.error("ajax getCouponList err", err);
      } finally {
        this.loadingData = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrap {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  .form {
    padding: 13px 15px;
  }
  .content-wrap {
    flex: 1;
    overflow-y: hidden;
  }
  .pagination {
    box-sizing: border-box;
    padding: 10px 20px;
  }
  .headSearch {
    flex: 1;
    justify-content: end;
    gap: 15px;
  }
}
.top-tip {
  line-height: 30px;
  color: $danger-color;
  margin-left: 20px;
}
</style>
